// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3uo3A","info":"Note_info__2-G11","note":"Note_note__2GNuh","actions":"Note_actions__oUgkP"};